import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./vistaDetallada.css";
import { useServiciosCombinados } from "../../hook/useServiciosCombinados";
import FadeInSection from "../FadeInSection/FadeInSection";
import { useMoneda } from "../../context/MonedaContext";
import { useConvertor } from "../../hook/useConversor";

const VistaDetalla = () => {
  const { id } = useParams();
  const { combinados, cargando, error } = useServiciosCombinados();
  const { t } = useTranslation();

  //aca utilizo el selector de monedas y guardo los precios convertidos en la variable preciosConvertidos
  const {moneda} = useMoneda();
  const {preciosConvertidos} = useConvertor(combinados,moneda)

  if (cargando) return <p className="cargando">Cargando...</p>;
  if (error) return <p className="error">Error: {error}</p>;

  const servicio = combinados.find((s) => s.id === parseInt(id));

  if (!servicio) {
    return <div className="Error">Error: Servicio no encontrado.</div>;
  }

  return (
    <FadeInSection>

      <div className="imgFondo">
        <section className="vistaDetallada">
          <img src={servicio.img} alt={t(servicio.titulo)} />
          <h3 className="tituloServicio">{t(servicio.titulo)}</h3>
          <div className="precioTiempo">
            <p>{
              //si es moneda ARS muestra el precio ars y si no mostrara el precio correspondiente al tipo de moneda
              moneda ==="ARS"?`${servicio.precio}`:preciosConvertidos[servicio.id] ? `${moneda} ${preciosConvertidos[servicio.id]}` : "cargandando...."
              }</p>
            <p>{t(servicio.tiempo)}</p>
          </div>
          <div className="caracteristicas">
            <p>{t(servicio.descripcion)}</p>
            <br />
            {Array.isArray(servicio.beneficios) && (
              <ul className="lista">
                {servicio.beneficios.map((item, i) => (
                  <li key={i}>{t(item)}</li>
                ))}
              </ul>
            )}
          </div>
          <button
            onClick={() =>
              (window.location.href = `https://wa.me/5492901508935?text=Hola%2C%20Me%20gustaría%20reservar%20un%20turno%20de%20${t(servicio.titulo)}%2C%20por%20favor`)
            }
          >
            Reservar un turno
          </button>
        </section>
      </div>
    </FadeInSection>
  );
};

export default VistaDetalla;
